module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-group text-dark"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
    staticClass: "choose-subject"
  }, [(_vm.isLoadingSubjects) ? _c('div', {
    staticClass: "choose-subject__spinner"
  }, [_c('div', {
    staticClass: "do-spinner"
  })]) : _c('dSelect', {
    attrs: {
      "items": _vm.sortedSubjects,
      "resetCounter": _vm.resetCounter,
      "multiple": false,
      "placeholder": _vm.$t('vue2.common.search'),
      "itemSpaceBetween": true,
      "selectedSubject": _vm.selectedSubject
    },
    on: {
      "enter": function($event) {
        _vm.isCreateAbsenceReason = true
      },
      "update": _vm.setSubject,
      "searchText": _vm.setTheSearchText,
      "onSearchTextDebounced": _vm.onSearchTextDebounced,
      "close": _vm.onCloseDSelect
    },
    scopedSlots: _vm._u([_vm._l((_vm.sortedSubjects), function(item, index) {
      return {
        key: "test",
        fn: function(slotProps) {
          return [_c('div', {
            staticClass: "choose-subject__event_type"
          }, [_vm._v("\n          " + _vm._s(slotProps.item.vSubjectType) + "\n        ")])]
        }
      }
    })], null, true)
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04134a49!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRequests/UserAbsence.vue
// module id = 1490
// module chunks = 1